import React from 'react';

const ArrowForward = props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      d="M8.71.71A.998.998 0 0 0 7.295.705a1 1 0 0 0 .002 1.413L12.17 7H.996A.996.996 0 0 0 0 8c0 .552.448 1 .996 1H12.17l-4.873 4.882a.997.997 0 0 0-.002 1.413c.39.39 1.029.381 1.415-.005l6.58-6.58a1.01 1.01 0 0 0 0-1.42L8.71.71z"
    />
  </svg>
);

export default ArrowForward;
